/**
 * OrderStatusService
 * Service for OrderStatus entity operations
 * Route: api/orderstatuses
 * Controller: OrderStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderStatusService
 * Handles order status CRUD operations
 * Maps to /api/orderstatuses endpoint
 */
export class OrderStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderStatusService.DEFAULT_SERVICE_PATH,
            basePath: OrderStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate order status cache
     * POST /api/orderstatuses/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate order status cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
OrderStatusService.DEFAULT_SERVICE_PATH = 'orders';
OrderStatusService.BASE_PATH = 'api/orderstatuses';
//# sourceMappingURL=OrderStatusService.js.map